<template>
  <div class="container test-results">
    <div class="row">
      <div class="col-sm-12">
        <div class="title-wrapper">
          <h1 class="title">Phonems audiogram results</h1>
        </div>
        <div class="title-divider"></div>
        <a @click.prevent="$router.back()" class="back-button" href="#"
        >
          <svg
            class="bi bi-arrow-left"
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M5.854 4.646a.5.5 0 0 1 0 .708L3.207 8l2.647 2.646a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 0 1 .708 0z"
            />
            <path
              fill-rule="evenodd"
              d="M2.5 8a.5.5 0 0 1 .5-.5h10.5a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
            />
          </svg
          >
          Back</a>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="position-wrapper">
          <div @click="showOnly('L')" class="left-wrapper">
            <div :style="{backgroundColor: visible.L ? '#0e9fcc' : '#fff'}" class="left-line"></div>
            <p>Left</p>
          </div>
          <div @click="showOnly('R')" class="right-wrapper">
            <div :style="{backgroundColor: visible.R ? '#fe4a49' : '#fff'}" class="right-line"></div>
            <p>Right</p>
          </div>
        </div>
      </div>
    </div>

    <Chart v-model="visible" :show-audiogram="true"/>

    <div class="row">
      <div class="col-sm-12">
        <div class="description-wrapper">
          <p>
            This graph shows the area where typical sounds of human language -
            phonemes - fall on audiogram. While people with normal hearing
            acuity can also hear sounds vowels and letter combinations.
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="button-wrapper">
          <router-link to="/select-gender" class="button-main">re-test</router-link>
          <router-link to="/hearing-loss-classification-results" class="button-main">next step</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import hearingLoss from "./hearing-loss-results";
  import EventBus from "../EventBus";

  export default {
    extends: hearingLoss,
    data() {
      return {
        polyLineData:[],
      }
    },
    mounted() {
      //mark a coordinate on canvas, used to store phonemes data
      EventBus.$on('afterCharts', ({chart}) => {
        this.$nextTick(() => {
          let canvas = document.querySelectorAll(".canvasjs-chart-canvas")
          canvas = canvas[canvas.length - 1]
          canvas.addEventListener('click', e => {
            let rect =  document.querySelector('.canvasjs-chart-container').getBoundingClientRect()
            let parentOffset = {
              top: rect.top + document.body.scrollTop,
              left: rect.left + document.body.scrollLeft
            }

            let relX = e.pageX - parentOffset.left
            let relY = e.pageY - parentOffset.top
            let xValue = chart.axisX[0].convertPixelToValue(relX)
            let yValue = chart.axisY[0].convertPixelToValue(relY)
            this.polyLineData.push({
              x: xValue,
              y: yValue
            })
          })
        })
      })
    },
  }
</script>
